import setFieldValue from "@iewcasia/Store/Handlers/CreateAccount/SetFieldValue";
import { CustomActions, CustomState } from "@iewcasia/Store/Reducers";
import {
    getRfqFormCheckboxBuilt,
    getRfqFormHintTextBuilt,
    getRfqFormLabelBuilt,
    OwnProps,
    setRequestFormEffects,
    validateFieldBy,
} from "@iewcasia/Widgets/CreateAccount/FormBaseComponent";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import TextField from "@insite/mobius/TextField";
import * as React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomState) => ({
    billingCompany: state.customCreateAccountForm.fieldValues.billingCompany,
    previouslyPurchased: state.customCreateAccountForm.fieldValues.previouslyPurchased,
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    DispatchProp<CustomActions>;

const BillingCompanyWidget: React.FC<Props> = ({ billingCompany, previouslyPurchased, setFieldValue: widgetSetFieldValue }) => {
    const label = translate("Company Name");
    const isRequired = true;
    const [fieldErrorMessage, setFieldErrorMessage] = React.useState("");

    setRequestFormEffects(isRequired, billingCompany, "billingCompany", () =>
        validateFieldBy(isRequired, label, billingCompany, setFieldErrorMessage),
    );

    const fieldChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        widgetSetFieldValue({ key: "billingCompany", value: event.target.value });
    };

    return (
        <TextField
            label={label}
            required={isRequired}
            value={billingCompany || ""}
            error={fieldErrorMessage}
            onChange={fieldChangeHandler}
        />
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(BillingCompanyWidget);
